import PropTypes from 'prop-types'

import SelectFilter from '../../shared_components/SelectFilter'
import SummariesTable from '../../shared_components/summaries_table/SummariesTable'

import {formatDate} from '../../../../../lib/dateTools'
import {removeDashesAndTitleize} from '../../../../../lib/tools'

const organizationName = (firmSummary, organizations) => {
  const firmOrganization = organizations.data.find(organization => organization.id === firmSummary['organization-id'])
  return firmOrganization ? firmOrganization.name : ''
}

const FirmSummariesTable = props => {
  const columns = [
    {
      Header: 'Firm Id',
      accessor: 'id',
      filterable: true,
      minWidth: 74
    },
    {
      Header: 'Firm',
      accessor: 'name',
      filterable: true,
      minWidth: 142
    },
    {
      Header: 'Active Clients',
      accessor: 'active-client-count',
      minWidth: 84
    },
    {
      Header: 'Pending Clients',
      accessor: 'pending-client-count',
      minWidth: 84
    },
    {
      Header: 'Advisor Seats Purchased',
      accessor: 'advisor-seats',
      minWidth: 100
    },
    {
      Header: 'Assistant Seats Purchased',
      accessor: 'assistant-seats',
      minWidth: 90
    },
    {
      id: 'last-login-date',
      Header: 'Most Recent Sign In',
      accessor: firmSummary => formatDate(firmSummary['last-login-date'])
    },
    {
      Filter: columnProps => (
        <SelectFilter {...columnProps} options={props.organizations.data} />
      ),
      Header: 'Organization',
      accessor: firmSummary => (
        organizationName(firmSummary, props.organizations)
      ),
      filterable: true,
      id: 'organization-id',
      minWidth: 130
    },
    {
      Filter: columnProps => (
        <SelectFilter
          {...columnProps}
          options={[
            {name: 'Firm', id: 'firm'},
            {name: 'Funeral Home', id: 'funeral_home'}
          ]}
        />
      ),
      Header: 'Firm Type',
      accessor: firmSummary => (
        removeDashesAndTitleize(firmSummary['firm-type'])
      ),
      filterable: true,
      id: 'firm-type',
      minWidth: 130
    },
    {
      Filter: columnProps => (
        <SelectFilter
          {...columnProps}
          options={[{name: 'Internal', id: 'true'}, {name: 'Not Internal', id: 'false'}]}
        />
      ),
      Header: 'Internal',
      accessor: firmSummary => (firmSummary.internal ? 'Internal' : ''),
      filterable: true,
      id: 'internal',
      minWidth: 130
    }
  ]

  return (
    <SummariesTable
      {...props}
      data={props.firmSummaries}
      defaultSorted={[{id: 'name', desc: false}]}
      columns={columns}
      loading={props.loadingFirms || props.loadingOrganizations}
    />
  )
}

FirmSummariesTable.propTypes = {
  firmSummaries: PropTypes.array,
  loadingFirms: PropTypes.bool,
  loadingOrganizations: PropTypes.bool,
  onFetchData: PropTypes.func,
  organizations: PropTypes.object,
  onRowClick: PropTypes.func,
  pages: PropTypes.number
}

export default FirmSummariesTable
